



















import { BreadcrumbList, WithContext } from 'schema-dts';
import { computed, defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import { useJsonLd } from '~/features/seo';

export default defineComponent({
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array as PropType<
        {
          path: string;
          label: string;
        }[]
      >,
      required: true,
    },
  },
  setup(props) {
    const { $config } = useContext();

    useJsonLd(
      computed<WithContext<BreadcrumbList>>(() => {
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: props.items?.map((i: any, idx) => {
            return {
              '@type': 'ListItem',
              name: i.label,
              item: `${$config.appURL}${i.path}`,
              position: idx + 1,
            };
          }),
        };
      })
    );
  },
  head: {},
});
